import { render, staticRenderFns } from "./GemList.vue?vue&type=template&id=b496fb28"
import script from "./GemList.vue?vue&type=script&lang=js"
export * from "./GemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports